import { useCallback } from "react";
import useAjax from "@apis/useAjax";
import { PEOPLE_TYPE } from "@icoach/constants/";
import { GET_CUSTOMERS_CUSTOMERID_API, GET_GUEST_OVERVIEW_OPTIONS_API, GET_GUEST_OVERVIEW_API, POST_GUESTS_API } from "@apis/apiPath";
import { useSnackbar } from "notistack";
import usePeopleApi from "@apis/usePeopleApi";
import useShowLoading from "@util/hook/useShowLoading";

const useCustomerGuestApi = () => {
	const Ajax = useAjax();
	const isLoading = useShowLoading();
	const { getPeopleApi } = usePeopleApi();
	const { enqueueSnackbar } = useSnackbar();

	// 名單總覽 options
	const getProspectOverviewOptionsApi = useCallback(
		async () => {
			const resp = await Ajax.get(GET_GUEST_OVERVIEW_OPTIONS_API);
			if (!resp) enqueueSnackbar("讀取資料失敗,請重新整理", { variant: "error" });
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	// 名單總覽列表
	const getProspectOverviewApi = useCallback(
		async parmas => {
			const resp = await Ajax.get(GET_GUEST_OVERVIEW_API, parmas);
			if (!resp) enqueueSnackbar("查詢失敗,請重新再操作一次", { variant: "error" });
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	// 新增名單初始資料
	const getAddProspectInitDataApi = useCallback(
		async (customerGuestID = 0) => {
			let result = {};
			isLoading(true);
			const customersGuestData = await Ajax.get(GET_CUSTOMERS_CUSTOMERID_API(customerGuestID));
			if (customersGuestData) Object.assign(result, { ...customersGuestData });
			const peopleOptions = await getPeopleApi(PEOPLE_TYPE.GUEST);
			if (peopleOptions) {
				Object.assign(result, {
					resource: {
						...(result.resource || {}),
						peopleOptions,
					},
				});
			}
			isLoading(false);
			return result;
		},
		// eslint-disable-next-line
		[]
	);

	// 新增名單
	const postAddProspectApi = useCallback(
		async params => {
			let resp = await Ajax.post(POST_GUESTS_API, params);
			if (resp) {
				if (resp?.isError !== true) enqueueSnackbar("新增成功", { variant: "success" });
				else return null;
			} else {
				enqueueSnackbar("新增失敗", { variant: "error" });
			}
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	return {
		getProspectOverviewOptionsApi,
		getProspectOverviewApi,
		getAddProspectInitDataApi,
		postAddProspectApi,
	};
};

export default useCustomerGuestApi;
